import React from 'react';
import { getActiveIcon } from 'library/helpers';
import { Tag } from 'antd';
import { DocLink, DocPages } from 'components/Help';
import ActionTypeInput from './input';

const assigneeWrapper = (assignees) => {
  const MAX_COUNT = 3;
  const count = assignees.length;
  return (
    assignees.map((item, index) => {
      const display = [];
      if (index < MAX_COUNT) {
        display.push(<div style={{ margin: '5px 0' }} key={`${item.last_name}, ${item.first_name}`}>{`${item.last_name}, ${item.first_name}`}</div>);
      }
      if (index === count - 1) {
        count - MAX_COUNT > 0 && display.push(<div style={{ margin: '5px 0' }} key="more">{`... +${count - MAX_COUNT}`}</div>);
      }

      return display;
    }));
};

const config = {
  // List Table
  list: {
    // Table Columns
    columns: [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: true,
        defaultSortOrder: 'ascend',
        width: '180px'
      },
      {
        title: 'Default Notification Types',
        dataIndex: 'default_notification_types',
        sorter: false,
        defaultSortOrder: 'ascend',
        width: '300px',
        render: (text, record) => (record.default_notification_types.map(item => item.name)).join(', ')
      },
      {
        title: 'Default Status',
        dataIndex: 'default_status__name',
        key: 'default_status__name',
        defaultSortOrder: 'ascend',
        sorter: true,
        width: '180px',
        render: (text, record) => (record.default_status.name)
      },
      {
        title: 'Default Priority',
        dataIndex: 'default_priority__name',
        key: 'default_priority__name',
        sorter: true,
        defaultSortOrder: 'ascend',
        width: '180px',
        render: (text, record) => (record.default_priority.name)
      },
      {
        title: 'Active',
        dataIndex: 'active',
        align: 'center',
        sorter: true,
        filterMultiple: false,
        filters: [
          {
            text: 'Active',
            value: true
          },
          {
            text: 'Inactive',
            value: false
          }
        ],
        width: '120px',
        render: (text, record) => getActiveIcon(record.active)
      },
      {
        title: 'Default Assignee Tags',
        dataIndex: 'default_user_assignee_tags',
        sorter: false,
        defaultSortOrder: 'ascend',
        width: '300px',
        render: (text, record) => (
          record.default_user_assignee_tags.map(
            item => (
              <div style={{ margin: '5px 0' }} key={item.qualified_name}><Tag>{item.qualified_name}</Tag></div>
            )
          )
        )
      },
      {
        title: 'Default Assignees',
        dataIndex: 'default_assignees',
        sorter: false,
        defaultSortOrder: 'ascend',
        width: '300px',
        render: (text, record) => assigneeWrapper(record.default_assignees)
      }
    ],
    // Deleting
    confirmMessage: item => (
      <div>
        <p>
          Are you sure you wish to delete the action type
          <b>{item.name}</b>
          ?
        </p>
        <p>
          This action cannot be undone.
        </p>
      </div>
    ),
    // Filtering
    sorter: {
      field: 'name',
      order: 'ascend'
    },
    filters: {},
    customFilters: {
      name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['name'],
        searchValue: ''
      },
      default_status__name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['default_status__name'],
        searchValue: ''
      },
      default_priority__name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['default_priority__name'],
        searchValue: ''
      }
    },
    // General
    title: <DocLink page={DocPages.actionTypes}>Action Types</DocLink>,
    scroll: {
      x: 1350,
      y: '100%'
    }
  },
  // Detail Screen
  detail: {
    // General
    emptyMessage: 'Please select an Action Type',
    title: 'Action Type',
    tabItems: [
      {
        key: 0,
        title: 'Details',
        component: props => (
          <ActionTypeInput
            {...props}
            title="Action Type"
          />
        )
      }
    ]
  }
};

export default config;
